import { motion } from "framer-motion";

const COACH_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_muscle-builder-268/artifacts/lhgs3f21_IMG_2974.jpeg";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative">
              <img
                src={COACH_PORTRAIT}
                alt="Amani Lubembe, fitness coach"
                className="w-full h-[600px] object-contain bg-[#0A0A0A]"
              />
              <div className="absolute -bottom-4 -right-4 bg-[#E63946] px-6 py-4">
                <span className="font-heading font-black uppercase text-lg leading-none">
                  Coach
                  <br />
                  Amani
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] text-neutral-400">
                The Coach
              </span>
            </div>
            <h2 className="font-heading font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              Meet Amani Lubembe
            </h2>
            <div className="mt-6 space-y-5 text-neutral-300 leading-relaxed text-base lg:text-lg max-w-xl">
              <p>
                Every serious lifter eventually hits a wall. The weights stop
                moving, the mirror stops changing, and motivation runs dry. I've
                been there — and I built a system to get past it.
              </p>
              <p>
                As an online fitness coach, I specialise in helping men who've
                plateaued finally build the muscle they've been chasing. No fluff,
                no guesswork — just structured progression engineered around your
                body and your schedule.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
